/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_VenuesInputs */

const th_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนามแข่ง`)
};

const en_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venues`)
};

const ja_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会場`)
};

const zh_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`场馆`)
};

const es_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pabellones`)
};

const pt_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginásios`)
};

const id_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat`)
};

const fr_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salles`)
};

const tl_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga venue`)
};

const vi_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa điểm`)
};

const ko_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경기장`)
};

const de_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallen`)
};

const ru_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Площадки`)
};

const tr_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salonlar`)
};

const it_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impianti`)
};

const pl_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hale`)
};

const uk_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Майданчики`)
};

const hi_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थल`)
};

const ar_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصالات`)
};

const ms_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat`)
};

const bn_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মাঠ`)
};

const zh_tw2_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`場館`)
};

const zh_hk2_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`場館`)
};

const ur_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقامات`)
};

const fa_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سالن‌ها`)
};

const sw_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kumbi`)
};

const nl_tab_venues = /** @type {(inputs: Tab_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zalen`)
};

/**
* | output |
* | --- |
* | "Venues" |
*
* @param {Tab_VenuesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const tab_venues = /** @type {((inputs?: Tab_VenuesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_VenuesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_tab_venues(inputs)
	if (locale === "ja") return ja_tab_venues(inputs)
	if (locale === "zh") return zh_tab_venues(inputs)
	if (locale === "es") return es_tab_venues(inputs)
	if (locale === "pt") return pt_tab_venues(inputs)
	if (locale === "id") return id_tab_venues(inputs)
	if (locale === "fr") return fr_tab_venues(inputs)
	if (locale === "tl") return tl_tab_venues(inputs)
	if (locale === "vi") return vi_tab_venues(inputs)
	if (locale === "ko") return ko_tab_venues(inputs)
	if (locale === "de") return de_tab_venues(inputs)
	if (locale === "ru") return ru_tab_venues(inputs)
	if (locale === "tr") return tr_tab_venues(inputs)
	if (locale === "it") return it_tab_venues(inputs)
	if (locale === "pl") return pl_tab_venues(inputs)
	if (locale === "uk") return uk_tab_venues(inputs)
	if (locale === "hi") return hi_tab_venues(inputs)
	if (locale === "ar") return ar_tab_venues(inputs)
	if (locale === "ms") return ms_tab_venues(inputs)
	if (locale === "bn") return bn_tab_venues(inputs)
	if (locale === "zh-TW") return zh_tw2_tab_venues(inputs)
	if (locale === "zh-HK") return zh_hk2_tab_venues(inputs)
	if (locale === "ur") return ur_tab_venues(inputs)
	if (locale === "fa") return fa_tab_venues(inputs)
	if (locale === "sw") return sw_tab_venues(inputs)
	if (locale === "nl") return nl_tab_venues(inputs)
	return en_tab_venues(inputs)
});